<div class="main-content">
  <img src="./assets/images/new-blast.svg" width=100 class="img-minimized">
  <p>Your</p>
  <p class="blast-name">{{data.blastName}} </p>
  <p>Blast has been sent!</p>
  <div class="footer-btns">
    <button mat-button class="footer-btn left-btn" (click)="goToBlastsHistory()">View</button>
    <button mat-button class="footer-btn" (click)="dialogRef.close()">Close</button>
  </div>
</div>